<div class="modal-header">
  <div class="modelHeading">
    <h6 class="modalTitle">Assigned Businesses ({{assignedBusinessesList.length}})</h6>
    <p>Below is the list of businesses assigned to you by the Overfoods admin.</p>
  </div>
  <button type="button" class="btnClose" (click)="onClose('false');"></button>
</div>
<div class="modal-body">
  <div class="businessList contacts_body">
    <ul class="contacts">
      <li *ngFor="let business of assignedBusinessesList;">
        <div class="d-flex flex-wrap">
          <div *ngIf="!business.businessDetails.businessLogo" class="imgBox middle initials-text">
            {{business.businessDetails.name | initials}}</div>
          <div *ngIf="business.businessDetails.businessLogo" class="imgBox middle">
            <img [src]="s3Directories?.business + business?.businessDetails.businessLogo">
          </div>
          <div class="d-sm-flex flex-wrap flex-1 align-items-center">
            <div class="user_info ms-0 ms-sm-2">
              <h6>{{business.businessDetails.name}}</h6>
              <span>{{business.businessDetails.email}} | {{business.businessDetails?.address ||
                "--"}}@if(business?.businessDetails?.addressLine1){,
                {{business?.businessDetails?.addressLine1}}}@if(business?.businessDetails?.zipCode){,
                {{business?.businessDetails?.zipCode}}}
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="note">
      <div class="chips">For any changes, please reach out to the Overfoods admin</div>
    </div>
  </div>
</div>